"use strict";

require("core-js/modules/es.string.trim.js");

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.px2rem = px2rem;
exports.fixePx = fixePx;
exports.updateFontSizeInHtml = updateFontSizeInHtml;
exports.minWidthInBrowser = void 0;

require("core-js/modules/es.parse-int.js");

require("core-js/modules/es.object.create.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.reduce.js");

require("core-js/modules/es.parse-float.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.string.split.js");

var _constant = require("@sk/cli-shared-utils/lib/constant");

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _isPlainObject = _interopRequireDefault(require("lodash/isPlainObject"));

var _vue = _interopRequireDefault(require("vue"));

var _dom = require("./dom");

var _util = require("./util");

var dpr = 0;
var screenWidth = 0;
var screenHeight = 0;
var minWidthInBrowser = 1280;
exports.minWidthInBrowser = minWidthInBrowser;
var standardScreenWidth = 1920;
var info = {
  dpr: dpr,
  scale: 0,
  rootValue: 0,
  rem: 0,
  deviceWidth: 0,
  deviceHeight: 0
};

function setRootFont(width, viewportWidth, force) {
  var doc = window.document;

  if (width < minWidthInBrowser && !(0, _util.isMobile)()) {
    width = minWidthInBrowser;
  }

  var rem = width * standardScreenWidth / viewportWidth / 10;

  if (!doc.documentElement) {
    return;
  }

  var rootFontSize = doc.documentElement.style.fontSize;

  if (!rootFontSize || force) {
    rootFontSize = rem * _constant.webRemOption.rootValue / (standardScreenWidth / 10) + 'px';
  }

  doc.documentElement.style.fontSize = rootFontSize;
  info.rem = rem;
  info.rootValue = viewportWidth / 10;
  return rootFontSize;
} // var doc = window.document


var DEFAULT_VIEWPORT_WIDTH = standardScreenWidth;
var envViewportWidth = parseInt(standardScreenWidth);
var width = !isNaN(envViewportWidth) && envViewportWidth > 0 ? envViewportWidth : DEFAULT_VIEWPORT_WIDTH; // const screenWidth = doc.documentElement.clientWidth
// setRootFont(screenWidth, width)

function cached(fn) {
  var cache = Object.create(null);
  return function cachedFn(str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
}

var scaleStyles = ['width', 'height', 'left', 'right', 'top', 'bottom', 'border', 'borderRadius', 'borderWidth', 'borderLeft', 'borderRight', 'borderTop', 'borderBottom', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'borderBottomWidth', 'margin', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom', 'padding', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'fontSize', 'lineHeight', 'transform', 'webkitTransform', 'WebkitTransform', 'mozTransform', 'MozTransform', 'itemSize'];
var hyphenateRE = /([^-])([A-Z])/g;
var vendorReg = /webkit|moz/i;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '$1-$2').replace(hyphenateRE, '$1-$2').toLowerCase();
}); // var vendorsReg = /webkit-|moz-|o-|ms-/
// function hyphenateKeys(obj) {
//   var res = {}
//   for (var key in obj) {
//     res[hyphenate(key)] = obj[key]
//   }
//   return res
// }

function hyphen(key) {
  return hyphenate(key.replace(vendorReg, function ($0) {
    return '-' + $0.toLowerCase() + '-';
  }));
}

function getAllStyles() {
  return Object.keys(scaleStyles.reduce(function (pre, key) {
    pre[key] = 1;
    pre[hyphen(key)] = 1;
    return pre;
  }, {}));
}

var allStyles = getAllStyles();
var config = {
  // scrollableTypes: ['scroller', 'list', 'waterfall', 'recycle-list'],
  // gestureEvents: ['panstart', 'panmove', 'panend', 'swipe', 'longpress', 'tap'],
  // // these components should not bind events with .native.
  // weexBuiltInComponents: ['div', 'container', 'text', 'image', 'gif', 'img', 'cell', 'a'],
  bindingStyleNamesForPx2Rem: allStyles
};
var bindingStyleNamesForPx2Rem$1 = config.bindingStyleNamesForPx2Rem;

var _supportHairlines;

function supportHairlines() {
  if (typeof _supportHairlines === 'undefined') {
    var dpr = window.devicePixelRatio;

    if (dpr && dpr >= 2 && document.documentElement) {
      var docElm = document.documentElement;
      var testElm = document.createElement('div');
      var fakeBody = document.createElement('body');
      var beforeNode = docElm.firstElementChild || docElm.firstChild;
      testElm.style.border = '0.5px solid transparent';
      fakeBody.appendChild(testElm);
      docElm.insertBefore(fakeBody, beforeNode);
      _supportHairlines = testElm.offsetHeight === 1;
      docElm.removeChild(fakeBody);
    } else {
      _supportHairlines = false;
    }
  }

  return _supportHairlines;
}

var tagMap$1 = {// text: text$2
};

var getTransformer$1 = function getTransformer$1(tag) {
  return tagMap$1[tag];
};

var transformer = {
  getTransformer: getTransformer$1
};
var getTransformer = transformer.getTransformer;
var getTransformer$2 = getTransformer;

function px2rem(px) {
  var rootValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constant.webRemOption.rootValue;
  return !_util.toRem ? px : px.replace(/([+-]?\d+(?:.\d*)?)([p|w]x)/g, function ($0, $1, $2) {
    if ($2 === 'wx') {
      // 'wx' -> px
      return $1 + 'px';
    } else {
      // 'px' -> rem
      var pxVal = parseFloat($1);
      var sign = pxVal > 0 ? 1 : pxVal < 0 ? -1 : 0;

      if (Math.abs(pxVal) <= 1) {
        return supportHairlines() ? sign * 0.5 + 'px' : sign * 1 + 'px';
      }

      return pxVal / (rootValue || info.rem) + 'rem';
    }
  });
}

function fixePx(num) {
  return (0, _util.remFontSize)(num);
}

var style = {
  methods: {
    _px2rem: function _px2rem(value) {
      var rootValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constant.webRemOption.rootValue;
      var conversionForbiddenPx2Rem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var this$1 = this; //  _conversionForbiddenPx2Rem;
      // if (conversionForbiddenPx2Rem && conversionForbiddenPx2Rem.length > 0) {
      //   conversionForbiddenPx2Rem = conversionForbiddenPx2Rem[0].split(',')
      // }

      if (typeof value === 'string') {
        if (value.indexOf(':') >= 0) {
          var arrValue = value.split(';');

          if (arrValue && arrValue.length > 0) {
            var objValue = {};

            for (var index = 0; index < arrValue.length; index++) {
              var _value = arrValue[index].split(':');

              var cssName = (0, _dom.trim)((0, _util.toCamelCase)(_value[0]));
              var cssValue = _value[1];

              if (cssName && cssValue) {
                objValue[cssName] = cssValue;
              }
            }

            return this$1._px2rem(objValue, rootValue, conversionForbiddenPx2Rem);
          }
        } else {
          return (value + '').replace(/[+-]?\d+(?:.\d*)?[pw]x/gi, function ($0) {
            return px2rem($0, rootValue);
          });
        }
      }

      if (typeof value === 'number') {
        return px2rem(value + '', rootValue);
      }

      if ((0, _isPlainObject["default"])(value)) {
        for (var k in value) {
          if (value.hasOwnProperty(k) && bindingStyleNamesForPx2Rem$1.indexOf(k) > -1 && !(conversionForbiddenPx2Rem.indexOf(k) > -1)) {
            value[k] = px2rem(value[k] + '', rootValue);
          }
        }

        return value;
      }

      if ((0, _isArray["default"])(value)) {
        for (var i = 0, l = value.length; i < l; i++) {
          this$1._px2rem(value[i], rootValue, conversionForbiddenPx2Rem);
        }

        return value;
      }
    },
    _processExclusiveStyle: function _processExclusiveStyle(styleObj, rootValue, tagName) {
      var transformer = getTransformer$2(tagName);
      return this._px2rem(transformer.transform(styleObj), rootValue);
    },
    _getParentRect: function _getParentRect() {
      var el = this.$el;
      var parent = el && el.parentElement;
      return parent && parent.getBoundingClientRect();
    },
    _rem2px: function _rem2px(num, minFontSize) {
      return (0, _util.remFontSize)(parseFloat(num), minFontSize);
    }
  }
};
var isInited = false;

function init$1(viewportWidth) {
  if (viewportWidth === void 0) viewportWidth = width;

  if (!isInited) {
    isInited = true;
    var doc = window.document;

    if (!doc) {
      console.error('[vue-render] window.document is undfined.');
      return;
    }

    if (!doc.documentElement) {
      console.error('[vue-render] document.documentElement is undfined.');
      return;
    }

    dpr = info.dpr = window.devicePixelRatio;
    screenWidth = doc.documentElement.clientWidth;
    screenHeight = doc.documentElement.clientHeight; // var resetDeviceHeight = function() {
    //   screenHeight = doc.documentElement.clientHeight
    //   var env = window.weex && window.weex.config.env
    //   info.deviceHeight = env.deviceHeight = screenHeight * dpr
    // }
    // set root font for rem.

    setRootFont(screenWidth, viewportWidth); // setMetaViewport(viewportWidth)
    // window.addEventListener('resize', resetDeviceHeight)

    /**
     * why not to use window.screen.width to get screenWidth ? Because in some
     * old webkit browser on android system it get the device pixel width, which
     * is the screenWidth multiply by the device pixel ratio.
     * e.g. ip6 -> get 375 for virtual screen width.
     */

    var scale = screenWidth / viewportWidth;
    /**
     * 1. if set initial/maximum/mimimum-scale some how the page will have a bounce
     * effect when user drag the page towards horizontal axis.
     * 2. Due to compatibility reasons, not to use viewport meta anymore.
     * 3. viewport meta should always be:
     *    <meta name="viewport"
     *      content="width=device-width,
     *      initial-scale=1,
     *      maximum-scale=1,
     *      user-scalable=no" />
     */

    Object.assign(info, {
      scale: scale,
      rootValue: viewportWidth / 10,
      deviceWidth: screenWidth * dpr,
      deviceHeight: screenHeight * dpr
    });
  }

  return info;
}

function updateFontSizeInHtml() {
  return setRootFont(window.document.documentElement.clientWidth, width, true);
} // let _inited = false


init$1();

_vue["default"].mixin(style);